var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-layout"
  }, [_c('div', {
    staticClass: "s-container text-center"
  }, [!_vm.isLoading && _vm.hitAgain ? [_c('h2', {
    staticClass: "s-text-xl s-text-gray-darker s-font-semibold s-mb-2"
  }, [_vm._v("您已領過此券囉！")]), _vm._m(0), _c('a', {
    staticClass: "s-btn s-btn-primary",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("確認")])] : _vm._e()], 2)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-mb-6 s-space-y-3"
  }, [_c('p', [_vm._v("如需確認此券使用狀態，請至POYA寶雅/寶家POYA HOME官方帳號優惠券匣查詢")])]);
}]

export { render, staticRenderFns }